"use client";

import BatIcon from "@/components/logos/BatIcon";
import { useUser } from "@/features/user/api/get-user";
import { usePingForAccess } from "@/features/user/api/ping-for-access";
import { useLogout } from "@/hooks/use-logout";
import { FaPowerOff } from "@react-icons/all-files/fa/FaPowerOff";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/no-access/")({
  head: () => ({
    meta: [{ title: "Reactor | No Access" }],
  }),
  component: NoAccessPage,
});

function NoAccessPage() {
  const { data: user, isLoading } = useUser();
  const { logout } = useLogout();
  const pingForAccess = usePingForAccess();

  if (user && user.has_access && !isLoading) {
    return <Navigate to="/atoms" />;
  }

  const handleOnClick = () => {
    pingForAccess.mutate();
  };

  return (
    <div className="relative flex min-h-screen w-screen items-center justify-center bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src="/images/login_bg.webp"
        className="absolute inset-0 z-0 hidden h-full w-full object-cover object-left md:block"
      />
      <div className="z-10 mx-3 flex w-full max-w-[530px] flex-col items-center rounded-[25px] bg-card px-5 pb-[52px] pt-[44px]">
        <div className="mb-3 flex h-[60px] w-[60px] items-center justify-center rounded-full bg-dark-green p-3 md:h-[72px] md:w-[72px]">
          <BatIcon />
        </div>
        <p className="mb-4 text-3xl">Not whitelisted</p>
        <button
          // to="https://telegram.me/Akio_ichi"
          // target="_blank"
          // rel="noopener noreferrer"
          disabled={pingForAccess.isPending}
          className="mb-5 flex h-[56px] w-[200px] items-center justify-center rounded-[12px] bg-dark-green text-green disabled:opacity-50"
          onClick={handleOnClick}
        >
          Click to request access
        </button>
        <p className="text-base text-gray-p">
          Reactor beta is invite-only, but you&apos;re on the waitlist now.
        </p>

        <button
          type="button"
          onClick={logout}
          className="mt-5 flex items-center justify-center gap-1 rounded-xl bg-dark-red p-2.5 pr-3 text-sm leading-none text-red hover:opacity-80"
        >
          <FaPowerOff />
          Log Out
        </button>
      </div>
    </div>
  );
}
